/* solum-b2c-lafayette-shopping.js
 * Wires the B2C Lafayette search section on /pages/myaccount.
 *
 *   1. On search submit → GET /storefront/b2c-shopping/search?q=…&customer_id=…
 *   2. Render result cards with KRW price only (no EUR shown)
 *   3. On "Add to cart" → POST /storefront/b2c-shopping/cart-item
 *      → backend forges a Shopify product (KRW price, online-store published)
 *      → returns variant_id
 *      → frontend calls /cart/add.js with that variant
 *      → on success, button flips to "Added · View cart" linking to /cart
 */
(function () {
  'use strict';
  var P = document.querySelector('.b2c-lfy');
  if (!P) return;

  var API   = P.getAttribute('data-api-url') || 'https://solum-concierge-api.onrender.com';
  var email = P.getAttribute('data-customer-email') || '';
  var cid   = P.getAttribute('data-customer-id') || '';
  var lang  = (P.getAttribute('data-lang') || 'en').toLowerCase();
  /* Marché (localization.country) : JP → prix en yen, sinon won */
  var MARKET = (P.getAttribute('data-market') || 'KR').toUpperCase();
  var isJpMkt = MARKET === 'JP';
  var isGuest = P.hasAttribute('data-guest');
  var isKo  = lang.indexOf('ko') >= 0;
  var isJa  = lang.indexOf('ja') >= 0;

  var T = {
    searching:   isKo ? '검색 중…'           : (isJa ? '検索中…'           : 'Searching…'),
    noResults:   isKo ? '결과가 없습니다.'    : (isJa ? '結果がありません。' : 'No results found.'),
    searchErr:   isKo ? '검색에 실패했습니다.': (isJa ? '検索に失敗しました。': 'Search failed.'),
    buyNow:      isKo ? '구매하기'            : (isJa ? '今すぐ購入'         : 'Buy now'),
    preparing:   isKo ? '주문 생성 중…'       : (isJa ? '注文を作成中…'      : 'Preparing order…'),
    redirecting: isKo ? '결제 페이지로 이동…' : (isJa ? '決済ページへ移動…'  : 'Redirecting to checkout…'),
    buyErr:      isKo ? '주문 생성 실패: '    : (isJa ? '注文作成失敗: '     : 'Order failed: '),
    loginNeeded: isKo ? '쇼핑하려면 로그인하세요.' : (isJa ? 'ショッピングするにはログインしてください。' : 'Please log in to shop.'),
    counter1:    isKo ? '개의 결과'           : (isJa ? '件の結果'           : ' result'),
    counterN:    isKo ? '개의 결과'           : (isJa ? '件の結果'           : ' results'),
    noImage:     isKo ? '이미지 없음'         : (isJa ? '画像なし'           : 'No image'),
    sourceBadge: isKo ? 'DEPARTMENT STORE'    : (isJa ? 'DEPARTMENT STORE'  : 'DEPARTMENT STORE'),
    allIncluded: isKo ? '세금 · 관세 · 배송비 포함' : (isJa ? '税金・関税・送料込み' : 'Tax, customs & shipping included'),
    videoIncluded: isKo ? '동영상 포함' : (isJa ? '動画付き' : 'Video included'),
  };

  // Lafayette / Mytheresa / 24S EUR sticker threshold above which we offer
  // a personalised unboxing video. Marc-defined (2026-05-26).
  var VIDEO_INCLUDED_EUR_THRESHOLD = 400;

  var krwLocale = isKo ? 'ko-KR' : (isJa ? 'ja-JP' : 'en-US');
  function fmtKRW(n) {
    var v = Math.round(Number(n) || 0);
    return (isJpMkt ? '¥' : '₩') + v.toLocaleString(krwLocale);
  }
  function esc(s) {
    if (s == null) return '';
    var d = document.createElement('div'); d.textContent = String(s);
    return d.innerHTML;
  }
  function $(id) { return document.getElementById(id); }

  var form = $('b2cLfySearchForm');
  var input = $('b2cLfyQ');
  var btn = $('b2cLfySearchBtn');
  var btnLabel = btn ? btn.querySelector('.b2c-lfy__search-btn-label') : null;
  var btnSpin = btn ? btn.querySelector('.b2c-lfy__search-btn-spinner') : null;
  var statusEl = $('b2cLfyStatus');
  var grid = $('b2cLfyResults');

  function setStatus(text, variant) {
    if (!statusEl) return;
    if (!text) { statusEl.hidden = true; statusEl.textContent = ''; return; }
    statusEl.hidden = false;
    statusEl.textContent = text;
    statusEl.className = 'b2c-lfy__status' + (variant ? ' b2c-lfy__status--' + variant : '');
  }
  function setSearchingState(busy) {
    if (!btn) return;
    btn.disabled = !!busy;
    if (btnLabel) btnLabel.hidden = !!busy;
    if (btnSpin)  btnSpin.hidden  = !busy;
  }

  function renderResults(results, totalQuery) {
    grid.innerHTML = '';
    if (!results || !results.length) {
      grid.innerHTML = '<div class="b2c-lfy__empty">' + esc(T.noResults) + '</div>';
      return;
    }
    var counterLabel = (results.length === 1) ? T.counter1 : T.counterN;
    setStatus(results.length + counterLabel, 'ok');

    var html = results.map(function (r, i) {
      var img = r.image_url ? ('<img class="b2c-lfy__card-img" loading="lazy" src="' + esc(r.image_url) + '" alt="' + esc(r.title) + '">')
                            : ('<div class="b2c-lfy__card-img b2c-lfy__card-img--missing">' + esc(T.noImage) + '</div>');
      var brand = r.brand ? '<div class="b2c-lfy__card-brand">' + esc(r.brand) + '</div>' : '';
      var videoBadge = (Number(r.price_eur) || 0) >= VIDEO_INCLUDED_EUR_THRESHOLD
        ? '<span class="b2c-lfy__card-source b2c-lfy__card-source--video">' + esc(T.videoIncluded) + '</span>'
        : '';
      return ''
        + '<article class="b2c-lfy__card" data-idx="' + i + '">'
        +   '<div class="b2c-lfy__card-media">'
        +     '<span class="b2c-lfy__card-source">' + esc(T.sourceBadge) + '</span>'
        +     videoBadge
        +     img
        +   '</div>'
        +   '<div class="b2c-lfy__card-body">'
        +     brand
        +     '<h3 class="b2c-lfy__card-title">' + esc(r.title) + '</h3>'
        +   '</div>'
        +   '<footer class="b2c-lfy__card-foot">'
        +     '<div class="b2c-lfy__card-price-wrap">'
        +       '<div class="b2c-lfy__card-price">' + fmtKRW(r.price_local || r.price_krw) + '<span class="b2c-lfy__card-price-unit">' + (isJpMkt ? 'JPY' : 'KRW') + '</span></div>'
        +       '<div class="b2c-lfy__card-price-incl">' + esc(T.allIncluded) + '</div>'
        +     '</div>'
        +     '<button type="button" class="b2c-lfy__card-btn" data-action="buy">'
        +       '<span class="b2c-lfy__card-btn-label">' + esc(T.buyNow) + '</span>'
        +     '</button>'
        +   '</footer>'
        + '</article>';
    }).join('');
    grid.innerHTML = html;

    // Store the item payload on each card so the add handler can access it
    Array.prototype.forEach.call(grid.querySelectorAll('.b2c-lfy__card'), function (card) {
      var idx = parseInt(card.getAttribute('data-idx'), 10);
      card.__b2cItem = results[idx];
    });
  }

  /* ─────────────────────────────────────────────────────────────
     Search
     ───────────────────────────────────────────────────────────── */
  function doSearch(q) {
    if (!q || !q.trim()) return;
    setStatus(T.searching, '');
    grid.innerHTML = '';
    setSearchingState(true);
    var url = API + '/storefront/b2c-shopping/search?q=' + encodeURIComponent(q)
            + '&market=' + encodeURIComponent(MARKET)
            + (cid ? '&customer_id=' + encodeURIComponent(cid) : '');
    fetch(url, { method: 'GET' })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (resp) {
        setSearchingState(false);
        if (!resp.ok || !resp.data || !resp.data.ok) {
          var msg = (resp.data && resp.data.error) || 'http_' + (resp.data && resp.data.status);
          setStatus(T.searchErr + ' (' + msg + ')', 'err');
          return;
        }
        renderResults(resp.data.results || [], q);
      })
      .catch(function (e) {
        setSearchingState(false);
        setStatus(T.searchErr + ' (' + (e && e.message) + ')', 'err');
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      doSearch(input.value);
    });
  }

  // Brand + reference quick lookup — concatenates "brand sku" into the main
  // search query so the user sees what was actually searched. Same pattern as
  // the Pro shopping page.
  var refForm = $('b2cLfyRefForm');
  if (refForm) {
    refForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var brand = ($('b2cLfyRefBrand') && $('b2cLfyRefBrand').value || '').trim();
      var sku   = ($('b2cLfyRefSku')   && $('b2cLfyRefSku').value   || '').trim();
      if (!sku) {
        if ($('b2cLfyRefSku')) $('b2cLfyRefSku').focus();
        return;
      }
      var q = (brand + ' ' + sku).trim();
      if (input) input.value = q;
      doSearch(q);
    });
  }

  /* ─────────────────────────────────────────────────────────────
     Buy now : backend creates a hidden product + draft order, returns
     invoice_url → we redirect the customer there to pay directly.
     ───────────────────────────────────────────────────────────── */
  grid.addEventListener('click', function (e) {
    var btnEl = e.target.closest('.b2c-lfy__card-btn[data-action="buy"]');
    if (!btnEl) return;
    var card = btnEl.closest('.b2c-lfy__card');
    var item = card && card.__b2cItem;
    if (!item) return;

    if (isGuest) {
      window.location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname + location.search);
      return;
    }

    btnEl.disabled = true;
    var labelEl = btnEl.querySelector('.b2c-lfy__card-btn-label');
    var originalLabel = labelEl ? labelEl.textContent : '';
    if (labelEl) {
      labelEl.innerHTML = '<span class="b2c-lfy__card-btn-spinner"></span> ' + esc(T.preparing);
    }

    fetch(API + '/storefront/b2c-shopping/cart-item', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        customer_id: cid,
        market: MARKET,
        title: item.title,
        brand: item.brand || '',
        source_url: item.link || '',
        source_key: item.source_key || '',
        image_url: item.image_url || '',
        price_eur: item.price_eur,
      }),
    })
    .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
    .then(function (resp) {
      if (!resp.ok || !resp.data || !resp.data.ok || !resp.data.invoice_url) {
        throw new Error((resp.data && resp.data.error) || 'create_failed');
      }
      if (labelEl) {
        labelEl.innerHTML = '<span class="b2c-lfy__card-btn-spinner"></span> ' + esc(T.redirecting);
      }
      // Redirect to Shopify-hosted invoice URL (B2C payment link)
      window.location.href = resp.data.invoice_url;
    })
    .catch(function (e) {
      console.error('[b2c-lfy] buy failed:', e);
      if (labelEl) labelEl.textContent = originalLabel;
      btnEl.disabled = false;
      alert(T.buyErr + (e && e.message || 'unknown'));
    });
  });
})();
